var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaveAsNewReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#667085;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.8,45c-0.9,0-1.7-0.3-2.3-1c-0.6-0.6-1-1.4-1-2.3V19c0-0.9,0.3-1.7,1-2.3c0.6-0.6,1.4-1,2.3-1H38 c0.4,0,0.8,0.1,1.2,0.2c0.4,0.2,0.7,0.4,1,0.7l4.6,4.6c0.3,0.3,0.5,0.6,0.7,1c0.2,0.4,0.2,0.8,0.2,1.2v5.2c0,0.5-0.2,0.8-0.5,1.2 c-0.3,0.3-0.7,0.5-1.2,0.5c-0.5,0-0.8-0.2-1.2-0.5s-0.5-0.7-0.5-1.2v-5.2L38,19H19.8v22.8h8.1c0.5,0,0.8,0.2,1.2,0.5 s0.5,0.7,0.5,1.2c0,0.5-0.2,0.8-0.5,1.2c-0.3,0.3-0.7,0.5-1.2,0.5H19.8z M32.8,46.7V44c0-0.2,0-0.4,0.1-0.6c0.1-0.2,0.2-0.4,0.4-0.6 l8.5-8.5c0.2-0.2,0.5-0.4,0.8-0.5c0.3-0.1,0.6-0.2,0.9-0.2c0.3,0,0.6,0.1,0.9,0.2s0.6,0.3,0.8,0.5l1.5,1.5c0.2,0.2,0.4,0.5,0.5,0.8 c0.1,0.3,0.2,0.6,0.2,0.9c0,0.3-0.1,0.6-0.2,0.9c-0.1,0.3-0.3,0.6-0.5,0.8l-8.5,8.5c-0.2,0.2-0.3,0.3-0.5,0.4s-0.4,0.1-0.6,0.1h-2.7 c-0.5,0-0.8-0.2-1.2-0.5C33,47.5,32.8,47.1,32.8,46.7z M35.3,45.8h1.5l4.9-5L41,40.1l-0.8-0.7l-5,4.9V45.8z M41,40.1l-0.8-0.7 l1.5,1.5L41,40.1z M23,27.1h11.4c0.5,0,0.8-0.2,1.2-0.5c0.3-0.3,0.5-0.7,0.5-1.2v-3.3c0-0.5-0.2-0.8-0.5-1.2 c-0.3-0.3-0.7-0.5-1.2-0.5H23c-0.5,0-0.8,0.2-1.2,0.5s-0.5,0.7-0.5,1.2v3.3c0,0.5,0.2,0.8,0.5,1.2C22.2,27,22.6,27.1,23,27.1z  M31.2,40.1h0.2l4.7-4.7v-0.2c0-1.4-0.5-2.5-1.4-3.5c-0.9-0.9-2.1-1.4-3.5-1.4c-1.4,0-2.5,0.5-3.5,1.4c-0.9,0.9-1.4,2.1-1.4,3.5 c0,1.4,0.5,2.5,1.4,3.5C28.7,39.7,29.8,40.1,31.2,40.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveAsNewReport);
export default __webpack_public_path__ + "static/media/save-as-new-report.e0de7aac2debe0faca130c17abe5777b.svg";
export { ForwardRef as ReactComponent };